
import { MapLocation } from '@/types/location';

// ASAG GYM Locations
export const asagGyms: MapLocation[] = [
  {
    id: 15001,
    name: "ASAG GYM - Jeddah (Al Nahda)",
    type: "Gym",
    devices: 3,
    coordinates: [21.612340205893176, 39.13016415092359],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-46",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
